import React from "react";
import styles from "./style.module.scss";


const Solution = ({title, info, icon}) => {
  return (
      <div className={styles.container}>
        <img className={styles.icon} src={icon} alt='icon' />

        <div className={styles.info}>
          <h1>{title}</h1>
          <p>{info}</p>
        </div>

      </div>
  );
};

export default Solution;
